export default (state = {}, action) => {
  switch (action.type) {
    case 'VALIDATIONDETAIL':
      return action.payload;
    default:
      return state;
  }
};
